export const LISTING_IMAGE_URL_PREFIX = 'https://lid.zoocdn.com/u/';
export const LISTING_IMAGE_URL_CROPPED_PREFIX = 'https://lid.zoocdn.com/';
export const ZOOPLA_PRODUCTION_URL = 'https://www.zoopla.co.uk';

export const TRACKING_EVENT = 'GAEvent';
export const TRACKING_CATEGORY = 'listing details';

export const ADS_MOBILE_BREAKPOINT = 960;

export const MOBILE_BREAKPOINT = 768;
export const TABLET_BREAKPOINT = 960;
